import { render, staticRenderFns } from "./FileNameDownloadable.vue?vue&type=template&id=b391d652&"
import script from "./FileNameDownloadable.vue?vue&type=script&setup=true&lang=js&"
export * from "./FileNameDownloadable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports